namespace Shared

open System


[<CLIMutable>]
type Song =
    { Id: Guid
      Artist: string
      Name: string
      Bpm : int
      Duration : int
      Spotify: string
      Content: string }

[<CLIMutable>]
type Lijst =
    { Id: Guid
      Name: string
      Created: DateTime
      SongLijst: Guid list }

type ShortSong = {
    ShortSongId: Guid
    Name: string
    Artist : string }

[<CLIMutable>]
type AgendaItem =
    {
        Id : Guid
        Created: DateTime
        Date: DateTime
        Note : string
    }

[<CLIMutable>]
type Data =
    { Songs: ShortSong list
      Lijsten: Lijst list
      Dates : AgendaItem list      }
module Song =
    let create artist name =
        { Id = Guid.NewGuid()
          Artist = artist
          Name = name
          Bpm=0
          Duration=0
          Spotify = ""
          Content = @"your content goes here

use commands on a separate line to style your content.
start the line with ':'
separate commands with ':'
example:
:prop:dark

available commands:
prop : propotional spaced font
mono : evenly paced font (mono spaced)
dark : dark theme (dark background, white font)
light :light theme (light background, dark font)
x: font with size x where x is a number 1-7. 1 is largest font, 7 is smallest font. 5 is the default font
bold : bold font
normal : normal font
black : black font
white : white font
red : red font
green : green font
yellow : yellow font
blue : blue font
lightblue : light blue font" }


    let isValid (song: Song) = song.Name<>"" && song.Artist<>""

    let song2ShortSong (song: Song) =
        { ShortSongId = song.Id
          Name = song.Name
          Artist = song.Artist }

    let NameAndArtist (song : ShortSong) =
        song.Name + " - " + song.Artist

module Lijst =
    let create name =
        { Id = Guid.NewGuid()
          Name = name
          Created = DateTime.Now
          SongLijst = [] }

    let isValid (lijst: Lijst) = true

module Agenda =
    let create date text =
        { Id = Guid.NewGuid()
          Date = date
          Created = DateTime.Now
          Note = text }

    let isValid (date: AgendaItem) = true// TODO: nader in te vullen

module Route =
    let builder typeName methodName = sprintf "/api/%s/%s" typeName methodName

type IBandAidApi =
    { getSongs: unit -> Async<ShortSong list>
      getSong: Guid -> Async<Song>
      getFullSongs : unit ->Async<Song list>
      getLijsten: unit -> Async<Lijst list>
      getData: unit -> Async<Data>
      addSong: Song -> Async<ShortSong list>
      addLijst: Lijst -> Async<Lijst list>
      verwijderLijst: Lijst -> Async<Lijst list>
      verwijderSong: Song -> Async<ShortSong list> 
      updateLijsten: Lijst -> Async<Lijst list>
      updateSongs: Song -> Async<ShortSong list>
      getDates: unit ->Async<AgendaItem list>
      addDate : AgendaItem ->Async<AgendaItem list>
      updateDates : AgendaItem ->Async<AgendaItem list>
      verwijderDate : AgendaItem ->Async<AgendaItem list>    }

